import styled from 'styled-components';

import { colors } from '../../theme/modules/colors';
import { BaseContainer } from '../BaseContainer';

export interface TagProps {
  backgroundColor?: string;
  color?: string;
}

export const Tag = styled(BaseContainer)<TagProps>`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  padding: 4px 8px;

  ${({ backgroundColor, color }) => `
    color: ${color ?? colors.neutral.ink.base};
    background-color: ${backgroundColor ?? colors.neutral.grey.base};
  `}
`;
